import React, { useState } from 'react';
import moment from 'moment-timezone';
// moment-timezone dipakai agar .tz('Asia/Jakarta') tersedia di halaman ini.
import SimpleCard from '@gull/components/cards/SimpleCard';
import Api from '../services/Api';
import AttachmentModal from './widgets/AttachmentModal';

const api = new Api();

const STATUS_OPTIONS = [
  { value: 0, text: 'Open' },
  { value: 1, text: 'Work-in-progress' },
  { value: 2, text: 'Done' },
];

// Halaman "Balas Laporan": dibuka dari tombol Balas di tabel Laporan Masalah.
// Data laporan diterima lewat location.state (react-router).
export default function SupportReply(props) {
  const report =
    props.location && props.location.state ? props.location.state : {};

  const [reply, setReply] = useState(report.admin_reply || '');
  const [status, setStatus] = useState(
    typeof report.status !== 'undefined' && report.status !== null
      ? report.status
      : 2
  );
  const [sending, setSending] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const goBack = () => {
    props.history.push('/dashboard/supportReports');
  };

  const submit = async () => {
    if (!reply.trim()) {
      setFeedback({ ok: false, text: 'Balasan tidak boleh kosong.' });
      return;
    }
    setSending(true);
    setFeedback(null);
    try {
      const res = await api.post(
        '/v1/support/reports/' + report.id + '/reply',
        { reply: reply.trim(), status: parseInt(status, 10) },
        true
      );
      if (res && res.status === 1) {
        setFeedback({
          ok: true,
          text: 'Balasan terkirim & notifikasi dikirim ke pelapor.',
        });
        setTimeout(goBack, 1200);
      } else {
        setFeedback({
          ok: false,
          text: 'Gagal mengirim balasan' + (res && res.error ? ` (${res.error})` : ''),
        });
      }
    } catch (e) {
      setFeedback({ ok: false, text: 'Terjadi kesalahan jaringan.' });
    }
    setSending(false);
  };

  const labelStyle = { fontWeight: 'bold', marginBottom: 4, display: 'block' };
  const boxStyle = {
    background: '#f5f5f5',
    borderRadius: 6,
    padding: 12,
    marginBottom: 16,
    whiteSpace: 'pre-wrap',
  };

  if (!report.id) {
    return (
      <SimpleCard title="Balas Laporan">
        <p>Data laporan tidak ditemukan. Silakan kembali ke daftar laporan.</p>
        <button className="btn btn-secondary" onClick={goBack}>
          Kembali
        </button>
      </SimpleCard>
    );
  }

  return (
    <SimpleCard title={`Balas Laporan #${report.id}`}>
      <div style={{ maxWidth: 720 }}>
        <div style={{ marginBottom: 16 }}>
          <span style={labelStyle}>Pelapor</span>
          <div>
            {report.username || '-'}{' '}
            {report.platform ? `· ${report.platform}` : ''}
          </div>
          <div style={{ color: '#888', fontSize: 13 }}>
            {report.created_at
              ? moment(report.created_at)
                  .tz('Asia/Jakarta')
                  .format('DD MMM YYYY HH:mm') + ' WIB'
              : ''}
          </div>
        </div>

        <span style={labelStyle}>Isi Laporan</span>
        <div style={boxStyle}>{report.description || '-'}</div>

        {report.attachment_url ? (
          <div style={{ marginBottom: 16 }}>
            <span style={labelStyle}>Lampiran</span>
            <AttachmentModal url={report.attachment_url} />
          </div>
        ) : null}

        {report.admin_reply ? (
          <div style={{ marginBottom: 16 }}>
            <span style={labelStyle}>Balasan Sebelumnya</span>
            <div style={boxStyle}>{report.admin_reply}</div>
          </div>
        ) : null}

        <span style={labelStyle}>Balasan Admin</span>
        <textarea
          value={reply}
          onChange={(e) => setReply(e.target.value)}
          rows={6}
          placeholder="Tulis balasan untuk pelapor..."
          style={{
            width: '100%',
            padding: 10,
            borderRadius: 6,
            border: '1px solid #ccc',
            marginBottom: 16,
          }}
        />

        <span style={labelStyle}>Ubah Status</span>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          style={{
            padding: 8,
            borderRadius: 6,
            border: '1px solid #ccc',
            marginBottom: 20,
            width: 240,
            display: 'block',
          }}
        >
          {STATUS_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>
              {o.text}
            </option>
          ))}
        </select>

        {feedback ? (
          <div
            style={{
              marginBottom: 16,
              padding: 10,
              borderRadius: 6,
              color: '#fff',
              background: feedback.ok ? '#27ae60' : '#c0392b',
            }}
          >
            {feedback.text}
          </div>
        ) : null}

        <div>
          <button
            className="btn btn-primary"
            onClick={submit}
            disabled={sending}
            style={{ marginRight: 12 }}
          >
            {sending ? 'Mengirim...' : 'Kirim Balasan'}
          </button>
          <button
            className="btn btn-secondary"
            onClick={goBack}
            disabled={sending}
          >
            Kembali
          </button>
        </div>
      </div>
    </SimpleCard>
  );
}
